import http from '@util/http';
import { finance } from '@api/req';

/**
 * 获取资金帐号列表
 */
export async function queryFundsBookList(params) {
  return http.get(finance.FUNDS_BOOK_LIST, params);
}

/**
 * 获取全部资金帐号列表
 * @param {} params
 * @returns {}
 */
export async function queryFundsBookAllList(params) {
  return http.get(finance.FUNDS_BOOK_LIST_ALL, params);
}

/**
 * 获取资金帐号明细
 * @param {} uuid
 * @returns {}
 */
export async function queryFundsBookInfo(uuid) {
  return http.get(finance.FUNDS_BOOK_INFO, { uuid });
}

/**
 * 保存资金帐号
 * @param {} params
 * @returns {}
 */
export async function querySaveFundsBook(params) {
  return http.post(finance.FUNDS_BOOK_SAVE, params);
}

/**
 * 启用资金账户
 * @param {} uuid
 * @returns {}
 */
export async function queryEnableFundsBook(uuid) {
  return http.get(finance.FUNDS_BOOK_ENABLE, { uuid });
}

/**
 * 禁用资金帐户
 * @param {} uuid
 * @returns {}
 */
export async function queryDisableFundsBook(uuid) {
  return http.get(finance.FUNDS_BOOK_DISABLE, { uuid });
}

/**
 * 删除资金帐号
 * @param {} uuid
 * @returns {}
 */
export async function queryDeleteFundsBook(uuid) {
  return http.get(finance.FUNDS_BOOK_DELETE, { uuid });
}

/**
 * 资金帐号统计
 * @param {} uuid
 * @returns {}
 */
export async function queryStatisticsFundsBook(uuid) {
  return http.get(finance.FUNDS_BOOK_STATISTICS, { uuid });
}

/**
 * 获取资金帐号流水
 * @param {} params
 * @returns {}
 */
export async function queryFundsRecordList(params) {
  return http.get(finance.FUNDS_RECORD_LIST, params);
}

/**
 * 获取资金帐号流水明细
 * @param {} uuid
 * @returns {}
 */
export async function queryFundsRecordInfo(uuid) {
  return http.get(finance.FUNDS_RECORD_INFO, { uuid });
}

/**
 * 保存资金帐号流水
 * @param {} params
 * @returns {}
 */
export async function querySaveFundsRecord(params) {
  return http.post(finance.FUNDS_RECORD_SAVE, params);
}

/**
 * 资金帐号流水导入
 * @param {} params
 * @returns {}
 */
export async function queryImportFundsRecord(params) {
  return http.post(finance.FUNDS_RECORD_IMPORT, params);
}

/**
 * 资金记录关联银行流水
 * @param {} params
 * @returns {}
 */
export async function querySaveFundsRecordRelate(params) {
  return http.post(finance.FUNDS_RECORD_RELATE, params);
}

/**
 * 未关联的资金记录
 * @param {} params
 * @returns {}
 */
export async function queryFundsRecordIncome(params) {
  return http.get(finance.FUNDS_RECORD_INCOME, params);
}

export async function queryDownloadFundRecordTemplate() {
  http.download(finance.DOWNLOAD_FUNDS_RECORD_TEMPLATE, {}, '资金帐号模板.xls');
}



// WEBPACK FOOTER //
// ./src/api/finance/funds.js